import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";
import StructuresForm from "../../components/Structures/StructuresForm";

const StructuresCreate = ({classes, machines, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('structures.new_structure')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('schedules.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Paper>
            <CardContent>
                <StructuresForm
                    formUrl={formUrl}
                    machines={machines}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default StructuresCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/structures/Create.jsx